module.exports = __webpack_public_path__ + "img/tobi.5d73aeea.jpg";